import { useIsAuthenticated } from 'react-auth-kit';
import { useLocation, Navigate } from 'react-router-dom';
import usePermission from '../hooks/usePermission';

const PrivateRoute = ({ children, loginPath, permission }: any) => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const { isUserHasPermission } = usePermission();

  if (!isAuthenticated()) {
    return (
      <Navigate to={loginPath || '/login'} state={{ from: location }} replace />
    );
  }

  if (permission && !isUserHasPermission(permission)) {
    return <Navigate to='/' replace />;
  }

  return children;
};

export default PrivateRoute;

